export const fullAppFlows = {
    FHA: {
        0: {
            component: ['borrowers'],
            validator: ['borrowersSchema'],
            stepperTitle: 'Verify Information',
            title: 'Verify your Information',
            subtitle:
                'Review and update your information. This will ensure we have the right information to contact you about your application.',
            disclaimer: `By clicking “Next”, you consent to be contacted, including via automated technology or artificial/prerecorded voice, by Freedom Mortgage and any of its current or future affiliated companies (collectively “Freedom Mortgage”) at the phone number(s) and email address provided for marketing purposes. You affirm that you are the subscriber of the phone number(s) and email address or that the subscriber has authorized you to provide this consent. Your consent is not a condition of purchase of goods or services from Freedom Mortgage. You can revoke your consent at any time by contacting Freedom Mortgage at 855-690-5900.`
        },
        1: {
            component: ['propertyInformation', 'titleInformation'],
            validator: ['propertyInfoSchema', 'titleInfoSchema'],
            stepperTitle: 'Property Information',
            title: 'Property Information',
            subtitle: 'Complete this section to tell us key information about the property and the borrowers.',
            alternateSubtitle:
                "Complete this section to specify your property's primary residence status and update key information about the property.",
            subStepsTemplate: {
                subSteps: ['Property Information', 'Title Information']
            }
        },
        2: {
            component: ['ethnicity', 'race', 'sex'],
            validator: ['ethnicitySchema', 'raceSchema', 'sexSchema'],
            stepperTitle: 'Demographic Information',
            title: 'Demographic Information: {{subStepValue}}',
            subtitle:
                'Federal law requires mortgage lenders to ask all applicants for their ethnicity, race, and sex. This information is collected to ensure that all applicants are treated fairly and to monitor lenders’ compliance with equal credit opportunity, fair housing and home mortgage disclosure laws.\n\nYou are not required to provide this information but are encouraged to do so. You may select one or more designations for” Ethnicity” and one or more designations for “Race.”\n\nUnder the law, lenders may not discriminate on the basis of this information or whether you choose to provide it. If you do not wish to provide some or all of this information, please check below.',
            subStepsTemplate: {
                subSteps: ['Ethnicity', 'Race', 'Sex']
            }
        },
        3: {
            component: ['borrowerInformation', 'militaryService', 'borrowerDeclarations', 'addressHistory'],
            validator: ['borrowerInformationSchema', 'militaryStatusSchema', 'borrowerDeclarationsSchema', 'addressHistorySchema'],
            stepperTitle: 'Personal Information',
            title: 'Personal Information',
            subtitle: 'It’s time to do a final review of your information before submitting your application.',
            subStepsTemplate: {
                subSteps: ['Borrower Information', 'Military Service', 'Borrower Declarations', 'Address History']
            }
        },
        4: {
            component: ['finalOffer'],
            stepperTitle: 'Submit Application',
            title: '{{firstName}}, your savings await!',
            disclaimer: `Upon clicking “Submit Application”, you will receive a Loan Estimate which provides a detailed breakdown of your estimated closing costs, monthly payment, interest rate and funds you will need to bring to closing.`,
            subtitle:
                "We're thrilled to present you with a personalized offer tailored just for you. You've taken the first step towards securing your dream, and we can't wait to be part of your journey."
        }
    },
    VA: {
        0: {
            component: ['borrowers'],
            validator: ['borrowersSchema'],
            stepperTitle: 'VA Verify Information',
            title: 'Verify your Information',
            subtitle:
                'Review and update your information. This will ensure we have the right information to contact you about your application.',
            disclaimer: `By clicking “Next”, you consent to be contacted, including via automated technology or artificial/prerecorded voice, by Freedom Mortgage and any of its current or future affiliated companies (collectively “Freedom Mortgage”) at the phone number(s) and email address provided for marketing purposes. You affirm that you are the subscriber of the phone number(s) and email address or that the subscriber has authorized you to provide this consent. Your consent is not a condition of purchase of goods or services from Freedom Mortgage. You can revoke your consent at any time by contacting Freedom Mortgage at 855-690-5900.`
        },
        1: {
            component: ['propertyInformation', 'titleInformation'],
            validator: ['propertyInfoSchema', 'titleInfoSchema'],
            stepperTitle: 'Property Information',
            title: 'Property Information',
            subtitle: 'Complete this section to tell us key information about the property and the borrowers.',
            alternateSubtitle:
                "Complete this section to specify your property's primary residence status and update key information about the property.",
            subStepsTemplate: {
                subSteps: ['Property Information', 'Title Information']
            }
        },
        2: {
            component: ['ethnicity', 'race', 'sex'],
            validator: ['ethnicitySchema', 'raceSchema', 'sexSchema'],
            stepperTitle: 'Demographic Information',
            title: 'Demographic Information: {{subStepValue}}',
            subtitle:
                'Federal law requires mortgage lenders to ask all applicants for their ethnicity, race, and sex. This information is collected to ensure that all applicants are treated fairly and to monitor lenders’ compliance with equal credit opportunity, fair housing and home mortgage disclosure laws.\n\nYou are not required to provide this information but are encouraged to do so. You may select one or more designations for” Ethnicity” and one or more designations for “Race.”\n\nUnder the law, lenders may not discriminate on the basis of this information or whether you choose to provide it. If you do not wish to provide some or all of this information, please check below.',
            subStepsTemplate: {
                subSteps: ['Ethnicity', 'Race', 'Sex']
            }
        },
        3: {
            component: ['borrowerInformation', 'militaryService', 'borrowerDeclarations', 'addressHistory'],
            validator: ['borrowerInformationSchema', 'militaryStatusSchema', 'borrowerDeclarationsSchema', 'addressHistorySchema'],
            stepperTitle: 'Personal Information',
            title: 'Personal Information',
            subtitle: 'It’s time to do a final review of your information before submitting your application.',
            subStepsTemplate: {
                subSteps: ['Borrower Information', 'Military Service', 'Borrower Declarations', 'Address History']
            }
        },
        4: {
            component: ['finalOffer'],
            stepperTitle: 'Submit Application',
            title: '{{firstName}}, your savings await!',
            disclaimer: `Upon clicking “Submit Application”, you will receive a Loan Estimate which provides a detailed breakdown of your estimated closing costs, monthly payment, interest rate and funds you will need to bring to closing.`,
            subtitle:
                "We're thrilled to present you with a personalized offer tailored just for you. You've taken the first step towards securing your dream, and we can't wait to be part of your journey."
        }
    }
};
